import { createAction, handleActions } from "redux-actions";

import { createOmniPaginationObject } from "../../utils/helpers";

const actionScope = "ADMIN_SESSION_";

export const adminSessionRequestFail = createAction(actionScope + "ADMIN_SESSION_REQUEST_FAIL");

//#region Actions

export const loadAdministratorODMRequest = createAction(
  actionScope + "LOAD_ADMINISTRATOR_ODM_REQUEST"
);
export const loadAdministratorODMSuccess = createAction(
  actionScope + "LOAD_ADMINISTRATOR_ODM_SUCCESS"
);

export const setAdministratorODMRequest = createAction(
  actionScope + "SET_ADMINISTRATOR_ODM_REQUEST"
);
export const setAdministratorODMSuccess = createAction(
  actionScope + "SET_ADMINISTRATOR_ODM_SUCCESS"
);

export const updateAdministratorRequest = createAction(
  actionScope + "UPDATE_ADMINISTRATOR_REQUEST"
);
export const updateAdministratorSuccess = createAction(
  actionScope + "UPDATE_ADMINISTRATOR_SUCCESS"
);

export const deleteAdministratorRequest = createAction(
  actionScope + "DELETE_ADMINISTRATOR_REQUEST"
);
export const deleteAdministratorSuccess = createAction(
  actionScope + "DELETE_ADMINISTRATOR_SUCCESS"
);

export const loadConversationConfigurationsRequest = createAction(
  actionScope + "LOAD_CONVERSATION_CONFIGURATIONS_REQUEST"
);
export const loadConversationConfigurationsSuccess = createAction(
  actionScope + "LOAD_CONVERSATION_CONFIGURATIONS_SUCCESS"
);

export const updateConversationConfigurationRequest = createAction(
  actionScope + "UPDATE_CONVESRATION_CONFIGURATION_REQUEST"
);
export const updateConversationConfigurationSuccess = createAction(
  actionScope + "UPDATE_CONVESRATION_CONFIGURATION_SUCCESS"
);

export const deleteConversationConfigurationRequest = createAction(
  actionScope + "DELETE_CONVESRATION_CONFIGURATION_REQUEST"
);
export const deleteConversationConfigurationSuccess = createAction(
  actionScope + "DELETE_CONVESRATION_CONFIGURATION_SUCCESS"
);

export const loadPracticesRequest = createAction(actionScope + "LOAD_PRACTICES_REQUEST");
export const loadPracticesSuccess = createAction(actionScope + "LOAD_PRACTICES_SUCCESS");
export const reflectUpdatedPracticeODMRequest = createAction(
  actionScope + "REFLECT_UPDATED_PRACTICE_ODM_REQUEST"
);
export const reflectUpdatedPracticeODMSuccess = createAction(
  actionScope + "REFLECT_UPDATED_PRACTICE_ODM_SUCCESS"
);

export const loadCommunicationTemplatesRequest = createAction(
  actionScope + "LOAD_COMMUNICATION_TEMPLATES_REQUEST"
);
export const loadCommunicationTemplatesSuccess = createAction(
  actionScope + "LOAD_COMMUNICATION_TEMPLATES_SUCCESS"
);

export const updateCommunicationTemplateRequest = createAction(
  actionScope + "UPDATE_COMMUNICATION_TEMPLATES_REQUEST"
);
export const updateCommunicationTemplateSuccess = createAction(
  actionScope + "UPDATE_COMMUNICATION_TEMPLATES_SUCCESS"
);

export const deleteCommunicationTemplateRequest = createAction(
  actionScope + "DELETE_COMMUNICATION_TEMPLATES_REQUEST"
);
export const deleteCommunicationTemplateSuccess = createAction(
  actionScope + "DELETE_COMMUNICATION_TEMPLATES_SUCCESS"
);

export const reflectUpdatedCommunicationTemplateODMRequest = createAction(
  actionScope + "REFLECT_UPDATED_COMMUNICATION_TEMPLATES_ODM_REQUEST"
);
export const reflectUpdatedCommunicationTemplateODMSuccess = createAction(
  actionScope + "REFLECT_UPDATED_COMMUNICATION_TEMPLATES_ODM_SUCCESS"
);

export const prosecuteCampaignRequest = createAction(actionScope + "PROSECUTE_CAMPAIGN_REQUEST");

export const prosecuteCampaignSuccess = createAction(actionScope + "PROSECUTE_CAMPAIGN_SUCCESS");

export const loadReportsRequest = createAction(actionScope + "LOAD_REPORTS_REQUEST");
export const loadReportsSuccess = createAction(actionScope + "LOAD_REPORTS_SUCCESS");

export const createReportRequest = createAction(actionScope + "CREATE_REPORT_REQUEST");
export const createReportSuccess = createAction(actionScope + "CREATE_REPORT_SUCCESS");

export const deleteReportRequest = createAction(actionScope + "DELETE_REPORT_REQUEST");
export const deleteReportSuccess = createAction(actionScope + "DELETE_REPORT_SUCCESS");

export const reflectUpdatedReportODMRequest = createAction(
  actionScope + "REFLECT_UPDATED_REPORT_ODM_REQUEST"
);
export const reflectUpdatedReportODMSuccess = createAction(
  actionScope + "REFLECT_UPDATED_REPORT_ODM_SUCCESS"
);

export const reportPagesSelector = state => state.adminSession.reportPages;
export const reportPaginationSelector = state => state.adminSession.reportPagination;

export const setReportODMRequest = createAction(actionScope + "SET_REPORT_ODM_REQUEST");
export const setReportODMSuccess = createAction(actionScope + "SET_REPORT_ODM_SUCCESS");

export const reflectUpdatedInviteODMRequest = createAction(
  actionScope + "REFLECT_UPDATED_INVITE_ODM_REQUEST"
);
export const reflectUpdatedInviteODMSuccess = createAction(
  actionScope + "REFLECT_UPDATED_INVITE_ODM_SUCCESS"
);

//#region Communication Request Paginiation

export const updateCommunicationRequestRequest = createAction(
  actionScope + "UPDATE_COMMUNICATION_REQUESTS_REQUEST"
);
export const updateCommunicationRequestSuccess = createAction(
  actionScope + "UPDATE_COMMUNICATION_REQUESTS_SUCCESS"
);

export const deleteCommunicationRequestRequest = createAction(
  actionScope + "DELETE_COMMUNICATION_REQUESTS_REQUEST"
);
export const deleteCommunicationRequestSuccess = createAction(
  actionScope + "DELETE_COMMUNICATION_REQUESTS_SUCCESS"
);

export const loadCommunicationRequestsRequest = createAction(
  actionScope + "LOAD_COMMUNICATION_REQUESTS_REQUEST"
);
export const loadCommunicationRequestsSuccess = createAction(
  actionScope + "LOAD_COMMUNICATION_REQUESTS_SUCCESS"
);

export const reflectUpdatedCommunicationRequestODMRequest = createAction(
  actionScope + "REFLECT_UPDATED_COMMUNICATION_REQUESTS_ODM_REQUEST"
);
export const reflectUpdatedCommunicationRequestODMSuccess = createAction(
  actionScope + "REFLECT_UPDATED_COMMUNICATION_REQUESTS_ODM_SUCCESS"
);

export const communicationRequestPagesSelector = state =>
  state.adminSession.communicationRequestPages;
export const communicationRequestPaginationSelector = state =>
  state.adminSession.communicationRequestPagination;
//#endregion

//#region Patient Paginiation

export const loadPartnersRequest = createAction(actionScope + "LOAD_PARTNERS_REQUEST");
export const loadPartnersSuccess = createAction(actionScope + "LOAD_PARTNERS_SUCCESS");

export const reflectUpdatedPartnerODMRequest = createAction(
  actionScope + "REFLECT_UPDATED_PARTNER_ODM_REQUEST"
);
export const reflectUpdatedPartnerODMSuccess = createAction(
  actionScope + "REFLECT_UPDATED_PARTNER_ODM_SUCCESS"
);

export const partnerPagesSelector = state => state.adminSession.partnerPages;
export const partnerPaginationSelector = state => state.adminSession.partnerPagination;

//#endregion

//#region Patient Paginiation
export const loadPatientsRequest = createAction(actionScope + "LOAD_PATIENTS_REQUEST");
export const loadPatientsSuccess = createAction(actionScope + "LOAD_PATIENTS_SUCCESS");

export const patientPagesSelector = state => state.adminSession.patientPages;
export const patientPaginationSelector = state => state.adminSession.patientPagination;

export const reflectUpdatedPatientODMRequest = createAction(
  actionScope + "REFLECT_UPDATED_PATIENT_ODM_REQUEST"
);
export const reflectUpdatedPatientODMSuccess = createAction(
  actionScope + "REFLECT_UPDATED_PATIENT_ODM_SUCCESS"
);
//#endregion

//#region Provider Paginiation
export const loadProvidersRequest = createAction(actionScope + "LOAD_PROVIDERS_REQUEST");
export const loadProvidersSuccess = createAction(actionScope + "LOAD_PROVIDERS_SUCCESS");

export const providerPagesSelector = state => state.adminSession.providerPages;
export const providerPaginationSelector = state => state.adminSession.providerPagination;

export const reflectUpdatedProviderODMRequest = createAction(
  actionScope + "REFLECT_UPDATED_PROVIDER_ODM_REQUEST"
);
export const reflectUpdatedProviderODMSuccess = createAction(
  actionScope + "REFLECT_UPDATED_PROVIDER_ODM_SUCCESS"
);
//#endregion

//#region Comm Invite Pagination - Created by Admins for Onboarding
export const loadCommInvitesRequest = createAction(actionScope + "LOAD_COMM_INVITES_REQUEST");
export const loadCommInvitesSuccess = createAction(actionScope + "LOAD_COMM_INVITES_SUCCESS");

export const commInvitePagesSelector = state => state.adminSession.commInvitePages;
export const commInvitePaginationSelector = state => state.adminSession.commInvitePagination;
//#endregion

//#region Shared Invite Pagination - Created by Admins for Onboarding
export const loadSharedInvitesRequest = createAction(actionScope + "LOAD_SHARED_INVITES_REQUEST");
export const loadSharedInvitesSuccess = createAction(actionScope + "LOAD_SHARED_INVITES_SUCCESS");

export const sharedInvitePagesSelector = state => state.adminSession.sharedInvitePages;
export const sharedInvitePaginationSelector = state => state.adminSession.sharedInvitePagination;
//#endregion

//#region autoInvite Pagination - System Generated for Partners to Share
export const loadAutoInvitesRequest = createAction(actionScope + "LOAD_AUTO_INVITES_REQUEST");
export const loadAutoInvitesSuccess = createAction(actionScope + "LOAD_AUTO_INVITES_SUCCESS");

export const autoInvitePagesSelector = state => state.adminSession.autoInvitePages;
export const autoInvitePaginationSelector = state => state.adminSession.autoInvitePagination;
//#endregion

//#region singleInvite Pagination - System Generated for Partners to Share
export const loadSingleInvitesRequest = createAction(actionScope + "LOAD_SINGLE_INVITES_REQUEST");
export const loadSingleInvitesSuccess = createAction(actionScope + "LOAD_SINGLE_INVITES_SUCCESS");

export const singleInvitePagesSelector = state => state.adminSession.singleInvitePages;
export const singleInvitePaginationSelector = state => state.adminSession.singleInvitePagination;
//#endregion

//#region selectors
export const allConversationConfigurationsSelector = state =>
  state.adminSession.conversationConfigurationODMs;
export const practiceODMsSelector = state => state.adminSession.practiceODMs;
export const patientODMsSelector = state => state.adminSession.patientODMs;
export const partnerODMsSelector = state => state.adminSession.partnerODMs;
export const providerODMsSelector = state => state.adminSession.providerODMs;
export const inviteODMsSelector = state => state.adminSession.inviteODMs;
export const reportODMsSelector = state => state.adminSession.reportODMs;
export const communicationRequestODMsSelector = state =>
  state.adminSession.communicationRequestODMs;
export const communicationTemplateODMsSelector = state =>
  state.adminSession.communicationTemplateODMs;
export const administratorODMSelector = state => state.adminSession.administratorODM;
export const inviteReportODMSelector = state => state.adminSession.inviteReportODM;

//#endregion

// initial state
const initialState = {
  administratorODM: null,

  conversationConfigurationODMs: null, //doesn't always need to be loaded

  practiceODMs: null, //this doesn't always need to be loaded,

  communicationTemplateODMs: null, //this doesn't always need to be loaded,

  relatedConversationConfigurationODMs: null, //self documenting verbosity, excuse the perspicacity

  inviteReportODM: null,

  //Shared Invites for in the system
  communicationRequestODMs: null, //this doesn't always need to be loaded,
  communicationRequestPages: {},
  communicationRequestPageLoading: false,
  communicationRequestPagination: createOmniPaginationObject(null, 10),

  //Shared Invites for in the system
  commInviteODMs: null,
  commInvitePages: {},
  commInvitePageLoading: false,
  commInvitePagination: createOmniPaginationObject(null, 10),

  //Shared Invites for in the system
  sharedInviteODMs: null,
  sharedInvitePages: {},
  sharedInvitePageLoading: false,
  sharedInvitePagination: createOmniPaginationObject(null, 10),

  //System Generated Invites for Partners to send out
  autoInviteODMs: null,
  autoInvitePages: {},
  autoInvitePageLoading: false,
  autoInvitePagination: createOmniPaginationObject(null, 10),

  //System Generated Invites for Partners to send out
  singleInviteODMs: null,
  singleInvitePages: {},
  singleInvitePageLoading: false,
  singleInvitePagination: createOmniPaginationObject(null, 10),

  //Patient Pagination
  patientODMs: null, //all ODMs in the current page
  patientPages: {},
  patientPageLoading: false,
  patientPagination: createOmniPaginationObject(null, 10),

  //Patient Pagination
  partnerODMs: null, //all ODMs in the current page
  partnerPages: {},
  partnerPageLoading: false,
  partnerPagination: createOmniPaginationObject(null, 10),

  //Patient Pagination
  providerODMs: null, //all ODMs in the current page
  providerPages: {},
  providerPageLoading: false,
  providerPagination: createOmniPaginationObject(null, 10),

  reportODMs: null, //this doesn't always need to be loaded,
  reportPages: {},
  reportPageLoading: false,
  reportPagination: createOmniPaginationObject(null, 10),

  // examplePage: {
  //   1: {
  //     odms: [ 'ODM1', 'ODM2' ],
  //   },
  // }
};

// reducers
export default handleActions(
  {
    [adminSessionRequestFail]: (state, { payload }) => ({
      ...state,
      //clean up any state
      loadingPatientPage: false,
      sharedInvitePageLoading: false,
      autoInvitePageLoading: false,
      singleInvitePageLoading: false,
      partnerPageLoading: false,
      providerPageLoading: false,
      reportPageLoading: false,
      patientPageLoading: false,
    }),

    [loadAdministratorODMRequest]: state => state,
    [loadAdministratorODMSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [setAdministratorODMRequest]: state => state,
    [setAdministratorODMSuccess]: (state, { payload }) => ({
      ...state,
      administratorODM: payload,
    }),

    [updateAdministratorRequest]: state => state,
    [updateAdministratorSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [deleteAdministratorRequest]: state => state,
    [deleteAdministratorSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [loadPracticesRequest]: state => state,
    [loadPracticesSuccess]: (state, { payload }) => ({
      ...state,
      practiceODMs: payload,
    }),

    [reflectUpdatedPracticeODMRequest]: state => state,
    [reflectUpdatedPracticeODMSuccess]: (state, { payload }) => ({
      ...state,
      practiceODMs: payload,
    }),

    [loadConversationConfigurationsRequest]: state => state,
    [loadConversationConfigurationsSuccess]: (state, { payload }) => ({
      ...state,
      conversationConfigurationODMs: payload,
    }),

    [updateConversationConfigurationRequest]: state => state,
    [updateConversationConfigurationSuccess]: (state, { payload }) => ({
      ...state,
      conversationConfigurationODMs: payload,
    }),

    [deleteConversationConfigurationRequest]: state => state,
    [deleteConversationConfigurationSuccess]: (state, { payload }) => ({
      ...state,
      conversationConfigurationODMs: payload,
    }),

    [loadPatientsRequest]: (state, { payload }) => ({
      ...state,
      patientPageLoading: true,
    }),

    [loadPatientsSuccess]: (state, { payload }) => ({
      ...state,
      patientPages: payload.pages,
      patientODMs: payload.items,
      patientPagination: payload.pagination,
      patientPageLoading: false,
    }),

    [reflectUpdatedPatientODMRequest]: (state, { payload }) => ({
      ...state,
      patientPages: {},
    }),
    [reflectUpdatedPatientODMSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [loadPartnersRequest]: (state, { payload }) => ({
      ...state,
      partnerPageLoading: true,
    }),

    [loadPartnersSuccess]: (state, { payload }) => ({
      ...state,
      partnerPages: payload.pages,
      partnerODMs: payload.items,
      partnerPagination: payload.pagination,
      partnerPageLoading: false,
    }),

    [reflectUpdatedPartnerODMRequest]: state => state,
    [reflectUpdatedPartnerODMSuccess]: (state, { payload }) => ({
      ...state,
      partnerODMs: payload,
    }),

    [loadProvidersRequest]: (state, { payload }) => ({
      ...state,
      providerPageLoading: true,
    }),
    [loadProvidersSuccess]: (state, { payload }) => ({
      ...state,
      providerPages: payload.pages,
      providerODMs: payload.items,
      providerPagination: payload.pagination,
      providerPageLoading: false,
    }),

    [loadCommInvitesRequest]: state => ({
      ...state,
      commInvitePageLoading: true,
    }),
    [loadCommInvitesSuccess]: (state, { payload }) => ({
      ...state,
      commInvitePages: payload.pages,
      commInviteODMs: payload.items,
      commInvitePagination: payload.pagination,
      commInvitePageLoading: false,
    }),

    [loadSharedInvitesRequest]: state => ({
      ...state,
      sharedInvitePageLoading: true,
    }),
    [loadSharedInvitesSuccess]: (state, { payload }) => ({
      ...state,
      sharedInvitePages: payload.pages,
      sharedInviteODMs: payload.items,
      sharedInvitePagination: payload.pagination,
      sharedInvitePageLoading: false,
    }),

    [loadAutoInvitesRequest]: (state, { payload }) => ({
      ...state,
      autoInvitePageLoading: true,
    }),
    [loadAutoInvitesSuccess]: (state, { payload }) => ({
      ...state,
      autoInvitePages: payload.pages,
      autoInviteODMs: payload.items,
      autoInvitePagination: payload.pagination,
      autoInvitePageLoading: false,
    }),

    [loadSingleInvitesRequest]: (state, { payload }) => ({
      ...state,
      singleInvitePageLoading: true,
    }),
    [loadSingleInvitesSuccess]: (state, { payload }) => ({
      ...state,
      singleInvitePages: payload.pages,
      singleInviteODMs: payload.items,
      singleInvitePagination: payload.pagination,
      singleInvitePageLoading: false,
    }),

    [reflectUpdatedProviderODMRequest]: state => state,
    [reflectUpdatedProviderODMSuccess]: (state, { payload }) => ({
      ...state,
      providerODMs: payload,
    }),

    [reflectUpdatedInviteODMRequest]: (state, { payload }) => ({
      ...state,
      // invitePages: {},
    }),

    [reflectUpdatedInviteODMSuccess]: state => state,

    [createReportRequest]: state => state,
    [createReportSuccess]: (state, { payload }) => ({
      ...state,
      reportODMs: payload,
    }),

    [loadReportsRequest]: (state, { payload }) => ({
      ...state,
      reportPageLoading: true,
    }),

    [loadReportsSuccess]: (state, { payload }) => ({
      ...state,
      reportPages: payload.pages,
      reportODMs: payload.items,
      reportPagination: payload.pagination,
      reportPageLoading: false,
    }),

    [deleteReportRequest]: state => state,
    [deleteReportSuccess]: (state, { payload }) => ({
      ...state,
      reportODMs: payload,
    }),

    [reflectUpdatedReportODMRequest]: state => state,
    [reflectUpdatedReportODMSuccess]: (state, { payload }) => ({
      ...state,
      reportODMs: payload,
    }),

    [setReportODMRequest]: state => state,
    [setReportODMSuccess]: (state, { payload }) => ({
      ...state,
      inviteReportODM: payload,
    }),

    [updateCommunicationRequestRequest]: state => state,
    [updateCommunicationRequestSuccess]: state => ({
      ...state,
    }),

    [deleteCommunicationRequestRequest]: state => state,
    [deleteCommunicationRequestSuccess]: (state, { payload }) => ({
      ...state,
      communicationRequestODMs: payload,
    }),

    [loadCommunicationRequestsRequest]: state => ({
      ...state,
      communicationRequestPageLoading: true,
    }),
    [loadCommunicationRequestsSuccess]: (state, { payload }) => ({
      ...state,
      communicationRequestPages: payload.pages,
      communicationRequestODMs: payload.items,
      communicationRequestPagination: payload.pagination,
      communicationRequestPageLoading: false,
    }),

    [reflectUpdatedCommunicationRequestODMRequest]: state => state,
    [reflectUpdatedCommunicationRequestODMSuccess]: (state, { payload }) => ({
      ...state,
      communicationRequestODMs: payload,
    }),

    [updateCommunicationTemplateRequest]: state => state,
    [updateCommunicationTemplateSuccess]: (state, { payload }) => ({
      ...state,
      communicationTemplateODMs: payload,
    }),

    [deleteCommunicationTemplateRequest]: state => state,
    [deleteCommunicationTemplateSuccess]: (state, { payload }) => ({
      ...state,
      communicationTemplateODMs: payload,
    }),

    [loadCommunicationTemplatesRequest]: state => state,
    [loadCommunicationTemplatesSuccess]: (state, { payload }) => ({
      ...state,
      communicationTemplateODMs: payload,
    }),

    [reflectUpdatedCommunicationTemplateODMRequest]: state => state,
    [reflectUpdatedCommunicationTemplateODMSuccess]: (state, { payload }) => ({
      ...state,
      communicationTemplateODMs: payload,
    }),

    [prosecuteCampaignRequest]: state => state,
    [prosecuteCampaignSuccess]: (state, { payload }) => ({
      ...state,
    }),
  },
  initialState
);
